import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import colors from '@/styles/colors';

export const RatingContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

interface RatingItemStyledProps {
  focused: boolean;
  actived: boolean;
}

const RatingFocusedStyle = css`
  color: ${colors.white};
  background-color: ${rgba(colors.primaryTint, 0.2)};
`;

const RatingActivedStyle = css`
  color: ${colors.white};
  background-color: ${colors.primaryTint};
`;

const RatingDefaultStyle = css`
  background-color: ${colors.white};
  color: ${rgba(colors.primaryTint, 0.2)};
  border: 2px solid ${rgba(colors.primaryTint, 0.2)};
`;

const getRatingStyle = ({ actived, focused }: RatingItemStyledProps) => {
  if (actived) {
    return RatingActivedStyle;
  }

  if (focused) {
    return RatingFocusedStyle;
  }

  return RatingDefaultStyle;
};

export const RatingItem = styled.button<RatingItemStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41px;
  height: 41px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  border-radius: 50%;

  ${getRatingStyle}
`;
